import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, costFormater, Text, useResponsive } from '@common-fe/common-fe';

import { useGetFundIcon } from '@/modules/investments/hooks';
import { FundPayload } from '@/modules/investments/SelfDirected/SelfDirected.types';

interface Props extends FundPayload {
  value: number;
  testId?: string;
}
const ConfirmModalItem: React.FC<Props> = ({ testId, title, stockCode, logo, value, status }) => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const handleGetFundIcon = useGetFundIcon();
  return (
    <Box
      direction="column"
      pad={{ vertical: '12px', horizontal: 'l' }}
      background="canvas"
      round="container2Round"
      border={{ size: 'small', color: 'border1' }}
      margin={{ top: 'xs' }}
    >
      <Box align="center" direction="row">
        <Box>
          {handleGetFundIcon({
            image: logo,
            status,
          })}
        </Box>
        <Box
          margin={{ left: 's' }}
          style={{
            flex: 2,
            position: 'relative',
          }}
          direction="column"
        >
          <Box width="100%">
            <Text data-testid={`${testId}_title`} tip={title} truncate weight={700}>
              {title}
            </Text>
            <Text>{stockCode}</Text>
          </Box>
        </Box>

        <Box
          direction="row"
          justify="between"
          margin={{ left: 's' }}
          style={isMobile ? undefined : { flex: 2 }}
        >
          <Text weight={700} data-testid={`${testId}_value`}>
            {costFormater(value, { isPrecision: true })}
          </Text>

          {!isMobile && <Text color="danger">{t('Full position liquidation')}</Text>}
        </Box>
      </Box>
      {isMobile && <Text color="danger">{t('Full position liquidation')}</Text>}
    </Box>
  );
};

export default ConfirmModalItem;
